export default __webpack_public_path__ + "static/8-e6c051b990665d27c1f86f54a5a2a903.jpg";